import { ListaDiccionaryEntity } from "./lista_diccionary_entity";

export class AsistenciaMedicaEntity {
    constructor(
        public CodAccPer?: number,
        public TipoSeguro?: string,
        public CodTipoSeguro?: number,
        public CodCliente?: number,
        public CiuCod?: number,
        public CodProducto?: number,
        public CodAseguradora?: number,
        public Poliza?: string,
        public InicioVigencia?: Date,
        public FinVigencia?: Date,
        public ValorAsegurado?: number,
        public Opciones?: ListaDiccionaryEntity[],
        public NombreProducto?: string,
        public NombreTipoSeguro?: string,
        public NombreAseguradora?: string,
        public Accion?: number,
        public Cancelar?: number,
        public Renovar?: number,
        public EstadoSolicitud?: number,
        public NombreTitular?: string,
        public TelefonoTitular ?: string,
        public EmailTitular ?: string,
        public EmpRol?: number,
        public EmpRolSiniestros?: number
    ) { }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/asistencia_medica_entity.ts